import axios from "axios";
import * as rax from "retry-axios";

const publicInstance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://gesmintservice.com"
      : "http://localhost:8000"
});

const privateInstance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://gesmintservice.com"
      : "http://localhost:8000"
});

const nohandlerPrivateInstance = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://gesmintservice.com"
      : "http://localhost:8000"
});

const nohandlerPrivateInstanceWithRetry = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? "https://gesmintservice.com"
      : "http://localhost:8000"
});
nohandlerPrivateInstanceWithRetry.defaults.raxConfig = {
  instance: nohandlerPrivateInstanceWithRetry,
  retry: 10,
  noResponseRetries: 10,
  retryDelay: 100,
  httpMethodsToRetry: ["POST"],
  statusCodesToRetry: []
};
const interceptorId = rax.attach(nohandlerPrivateInstanceWithRetry);

const setPrivateInstanceHeader = function(token) {
  privateInstance.defaults.headers.common["Authorization"] = `JWT ${token}`;
  nohandlerPrivateInstance.defaults.headers.common[
    "Authorization"
  ] = `JWT ${token}`;
  nohandlerPrivateInstanceWithRetry.defaults.headers.common[
    "Authorization"
  ] = `JWT ${token}`;
};

if (process.env.NODE_ENV === "production") {
  axios.defaults.baseURL = "https://gesmintservice.com";
} else {
  axios.defaults.baseURL = "http://localhost:8000";
}

const mapUrl = function(url) {
  const lastChar = url.substr(url.length - 1);
  if (lastChar === "?" || lastChar === "&") {
    return `${url.substring(0, url.length - 1)}/`;
  } else {
    return url;
  }
};

export {
  publicInstance,
  privateInstance,
  nohandlerPrivateInstance,
  nohandlerPrivateInstanceWithRetry,
  setPrivateInstanceHeader,
  mapUrl,
  interceptorId
};
